import { AuthInterceptor } from './auth.interceptor.service';
import { ErrorInterceptor } from './error.interceptor.service';

import { HTTP_INTERCEPTORS } from '@angular/common/http';

export const HttpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
];
